// extracted by mini-css-extract-plugin
module.exports = {"singleCard":"SingleCard_singleCard__1Eg0b","singleCardSmall":"SingleCard_singleCardSmall__mdBCv","header":"SingleCard_header__pTqWj"};